import clsx from 'clsx';
import { oneOf, string } from 'prop-types';

const Skeleton = ({ type = 'text', classNames = '', size = 'initial' }) => {
  const skeletonSize = {
    xs: 'w-4 h-4',
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24',
    xxl: 'w-48 h-48',
    initial: ''
  }[size];

  switch (type) {
    case 'text':
      return <div className={clsx('animate-pulse mb-2 bg-gray-200 rounded', classNames, skeletonSize)} />;
    case 'square':
      return <div className={clsx('animate-pulse bg-gray-200 rounded', classNames, skeletonSize)} />;
    case 'circle':
      return <div className={clsx('animate-pulse bg-gray-200 rounded-full', classNames, skeletonSize)} />;
    default:
      return <div className={clsx('animate-pulse bg-gray-200 rounded', classNames, skeletonSize)} />;
  }
};

Skeleton.propTypes = {
  type: oneOf(['text', 'square', 'circle']),
  classNames: string,
  size: string
};

export default Skeleton;
